import React from 'react';
import LabelStyles from './styles';
import PropTypes from 'prop-types';

const LabelTitle = ({ content, color }) => (
	<LabelStyles variant="h3" color={color}>
		{content}
	</LabelStyles>
);

export default LabelTitle;

LabelTitle.defaultProps = {
	content: 'Click on me'
};

LabelTitle.propTypes = {
	content: PropTypes.string.isRequired
};
